<bl-modal-content #content
  [title]="title"
  [footerButtonType]="footerButtonType"
>
  <div body>
    <share-generic-print-form #genericForm
      [genericPrint]="genericPrint"
      [reportLayoutSettingList]="reportLayoutSettingList"
      [printerSettingList]="printerSettingList"
    >
      <div *ngIf="isNumberCarsSummary" form-footer>
        <div class="generic-print-form__group">
          <div class="generic-print-form__label">印刷期間</div>
          <div class="generic-print-form__item">
            <bl-date
              [value]="reserveSearchCondition?.searchStartDate"
              [validator]="blFormGroup?.validatorGroup['ReserveSearchCondition#searchStartDate']"
              (changeEvent)="onChangeSearchStartDate($event)"
            ></bl-date>
            <span class="period">～</span>
            <bl-date
              [value]="reserveSearchCondition?.searchEndDate"
              [validator]="blFormGroup?.validatorGroup['ReserveSearchCondition#searchEndDate']"
              (changeEvent)="onChangeSearchEndDate($event)"
            ></bl-date>
          </div>
        </div>
        <div class="generic-print-form__group">
          <div class="generic-print-form__label">商品サービス</div>
          <div class="generic-print-form__item">
            <div class="summary-select">
              <bl-select
                [(value)]="reserveSearchCondition && reserveSearchCondition.itemServiceNum"
                [items]="itemServicesettingList"
                [option]="{ valueProperty: 'itemServiceNum', labelProperty: 'itemServiceName' }"
              ></bl-select>
            </div>
            <div class="generic-print-form__inner-label">予約ステータス</div>
            <div class="summary-select">
              <bl-select
                [(value)]="reserveSearchCondition && reserveSearchCondition.reserveSearchStatus"
                [items]="ReserveSearchStatusArray"
                [option]="{ valueProperty: 'value', labelProperty: 'text' }"
              ></bl-select>
            </div>
          </div>
        </div>
        <div class="generic-print-form__group">
          <div class="generic-print-form__label">未入庫区分</div>
          <div class="generic-print-form__item">
            <div class="summary-select">
              <bl-select
                [(value)]="reserveSearchCondition && reserveSearchCondition.carEnterDiv"
                [items]="CarEnterDivArray"
                [option]="{ valueProperty: 'value', labelProperty: 'text' }"
              ></bl-select>
            </div>
            <div class="generic-print-form__inner-label">集計区分</div>
            <div class="summary-select">
              <bl-select
                [(value)]="reserveSearchCondition && reserveSearchCondition.reserveTallyUnitDiv"
                [items]="ReserveTallyUnitDivArray"
                [option]="{ valueProperty: 'value', labelProperty: 'text' }"
              ></bl-select>
            </div>
          </div>
        </div>
      </div>
    </share-generic-print-form>
  </div>
  <div footer>
    <share-generic-print-footer #genericFooter></share-generic-print-footer>
  </div>

</bl-modal-content>



// WEBPACK FOOTER //
// ./src/app/feature/reserve-print-modal/reserve-print-modal.component.html